import { Controller } from "@hotwired/stimulus"
import { lineChartOption, lineChartColors, getAllLabelsFromData, genderCodeToText } from "./graph_helper"
import { downloadCsvFromCharts } from "./csv_helper"
import moment from 'moment';

export default class extends Controller {
  static targets = ['mediaTypeGraphArea', 'followerTypeGraphArea', 'genderGraphArea', 'ageGraphArea', 'maleAgeGraphArea', 'femaleAgeGraphArea', 'unknowAgeGraphArea']

  static values = {
    mediaEndpoint: String,
    followTypeEndpoint: String,
  }

  async connect() {
    this.chartsData = []
    this.createViewsMediaTypeChart()
    this.createViewsFollowTypeChart()
  }

  async createViewsMediaTypeChart(){
    const res = await fetch(this.mediaEndpointValue)
    const points = await res.json()

    this.createMediaTypeChart(points)
  }

  async createViewsFollowTypeChart(){
    const res = await fetch(this.followTypeEndpointValue)
    const points = await res.json()

    this.createFollowTypeChart(points)
  }

  createMediaTypeChart(rawData){
    const labels = getAllLabelsFromData(rawData)
    const data = this.parseMediaTypeData(rawData, labels)
    this.chartsData.push(data)
    this.drawMediaTypeChart(data, 'media_product_type')
  }

  createFollowTypeChart(rawData){
    const labels = getAllLabelsFromData(rawData)
    const data = this.parseMediaTypeData(rawData, labels)
    this.chartsData.push(data)
    this.drawMediaTypeChart(data, 'follow_type')
  }

  parseMediaTypeData(rawData, labels){
    let xAxis = []
    let mediaDatasets = {}
    labels.forEach(label => {
      mediaDatasets[label] = []
    })
    rawData.forEach((data, idx) => {
      xAxis.push(data.labels)
      labels.forEach(label => {
        mediaDatasets[label][idx] = 0
      })
      data.points.forEach(point => {
        let key = point.dimension_values[0]
        mediaDatasets[key][idx] = point.value
      })
    })

    let datasets = []
    labels.sort().forEach((label, idx) => {
      datasets.push({
        label: label,
        fill: false,
        data: mediaDatasets[label],
        borderColor: lineChartColors[label],
        backgroundColor: lineChartColors[label],
        lineTension: 0
      })
    })
    return {
      labels: xAxis,
      datasets: datasets
    }

  }

  drawMediaTypeChart(data, breakdownType){
    const options = lineChartOption
    let ctx
    if(breakdownType == 'media_product_type'){
      ctx = this.mediaTypeGraphAreaTarget.getContext('2d');
    }
    else if (breakdownType == 'follow_type'){
      ctx = this.followerTypeGraphAreaTarget.getContext('2d');
    }
    this.chart = new Chart(
      ctx, {
      type: 'line',
      cubicInterpolationMode: 'monotone',
      data,
      options
    })
  }

  downloadCsv(){
    let fileName = `user_insights_views_${moment().format('YYYY/MM/DD HH:mm:ss')}`
    downloadCsvFromCharts(this.chartsData, fileName)
  }
}
